import React from 'react'
import './Landing.css'
import InfoBar from '../../components/InfoBar/InfoBar'
import NavBar from '../../components/NavBar/NavBar'
import Hero from '../../components/Hero/Hero'
import FeaturedBouquets from '../../components/FeaturedBouquets/FeaturedBouquets'
import HowItWorks from '../../components/HowItWorks/HowItWorks'
import ImageCards from '../../components/ImageCards/ImageCards'
import Testimonials from '../../components/Testimonials/Testimonials'
import SendLove from '../../components/SendLove/SendLove'
import PaymentMethod from '../../components/PaymentMethod/PaymentMethod'
import Footer from '../../components/Footer/Footer'
function Landing() {
  return (
    <>
    <InfoBar/>
    <NavBar/>
    <Hero/>
    <FeaturedBouquets/>
    <HowItWorks/>
    <ImageCards/>
    <Testimonials/>
    <SendLove/>
    <PaymentMethod/>
    <Footer/>
    </>
  )
}
export default Landing
